module.exports = __webpack_public_path__ + "static/media/client-twilio.a2c0538d.png";